<form [formGroup]="subscriptionForm">
  <div class="input-row column-on-small">
    <mat-form-field appearance="outline" class="half-width">
      <mat-label for="FirstName">First Name</mat-label>
      <input
        matInput
        id="FirstName"
        [formControlName]="'FirstName'"
        required
        aria-required="true"
        autocomplete="given-name"
      />
      @if (subscriptionForm.controls['FirstName'].invalid) {
        <mat-error id="firstNameError"> First Name is required </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="half-width">
      <mat-label for="LastName">Last Name</mat-label>
      <input
        matInput
        id="LastName"
        [formControlName]="'LastName'"
        required
        aria-required="true"
        autocomplete="family-name"
      />
      @if (subscriptionForm.controls['LastName'].invalid) {
        <mat-error id="lastNameError"> Last Name is required </mat-error>
      }
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="StakeEmail">Email Address</mat-label>
    <input
      matInput
      id="StakeEmail"
      [formControlName]="'StakeEmail'"
      type="email"
      required
      aria-required="true"
      autocomplete="email"
    />
    @if (subscriptionForm.controls['StakeEmail'].hasError('required')) {
      <mat-error id="stakeEmailError"> Email Address is required </mat-error>
    }
    @if (
      subscriptionForm.controls['StakeEmail'].hasError('email') &&
      !subscriptionForm.controls['StakeEmail'].hasError('required')
    ) {
      <mat-error id="stakeEmailError"> Enter a valid email address </mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="MailAddress1">Mail Address 1</mat-label>
    <input
      matInput
      id="MailAddress1"
      [formControlName]="'Mail1AddressLine1'"
      [attr.aria-describedby]="'mailAddress1Error'"
      aria-required="true"
      autocomplete="address-line1"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="MailAddress2">Mail Address 2</mat-label>
    <input matInput id="MailAddress2" [formControlName]="'Mail1AddressLine2'" autocomplete="address-line2" />
  </mat-form-field>

  <div class="input-row column-on-small">
    <mat-form-field appearance="outline" class="half-width">
      <mat-label for="CityTown">City/Town</mat-label>
      <input matInput id="CityTown" [formControlName]="'Mail1City'" autocomplete="address-level2" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="quarter-width">
      <mat-label for="State">State</mat-label>
      <input matInput id="State" [formControlName]="'Mail1State'" autocomplete="address-level1" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="quarter-width">
      <mat-label for="Mail1ZipCode">Zip Code</mat-label>
      <input
        matInput
        id="Mail1ZipCode"
        [formControlName]="'Mail1ZipCode'"
        required
        aria-required="true"
        autocomplete="postal-code"
      />
      @if (subscriptionForm.controls['Mail1ZipCode'].hasError('required')) {
        <mat-error id="mail1ZipCodeError"> Zip Code is required </mat-error>
      }
      @if (subscriptionForm.controls['Mail1ZipCode'].hasError('pattern')) {
        <mat-error id="mail1ZipCodeError"> Zip Code must be 5 digits </mat-error>
      }
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="Organization">Organization</mat-label>
    <input matInput id="Organization" [formControlName]="'Organization'" autocomplete="organization" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="Travel">How do you travel?</mat-label>
    <mat-select [formControlName]="'TravelIds'" id="Travel" multiple>
      @for (travelType of stakeholderInfo?.TravelList; track travelType) {
        <mat-option [value]="travelType.Key" (onSelectionChange)="onTravelOptionChange($event, travelType)">
          {{ travelType.Value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div aria-live="polite" class="sr-only">
    {{ travelAnnouncement }}
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="OrganizationType">Organization Type</mat-label>
    <mat-select [formControlName]="'OrganizationTypeList'" id="OrganizationType" multiple>
      @for (type of organizationTypes; track type) {
        <mat-option [value]="type.Key" (onSelectionChange)="onOrganizationTypeOptionChange($event, type)">
          {{ type.Value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div aria-live="polite" class="sr-only">
    {{ organizationTypeAnnouncement }}
  </div>

  @if (projectInfo?.ProjectName) {
    <div>
      <mat-checkbox [formControlName]="'IsReceiveEmailUpdate'">
        I would like to receive emails about {{ projectInfo?.ProjectName }}
      </mat-checkbox>
    </div>
  }

  @if (!hideButtons) {
    <div class="button-row" [ngClass]="{ 'no-back-url': goBackUrl === null || goBackUrl === '' }">
      <button class="blue-outline-button" (click)="goBack()" type="button">Go Back</button>
      <button
        class="blue-button"
        [disabled]="submitInProgress || !subscriptionForm.valid"
        (click)="onSubmit()"
        type="submit"
      >
        Submit
      </button>
    </div>
  }
</form>
